import styled, { css } from 'styled-components'
import { Colors, Spacing, Typography } from 'cio-design-library/design-tokens'
import { FontWeights } from 'builder/styles/typography'
import ResumeScore from 'builder/components/ResumeScore'
import Media from 'builder/styles/media'
import { StarsIcon } from './StarsIcon'

export const Container = styled.div`
  padding: 24px 36px;
  margin-bottom: ${Spacing['3XS']};
  background: white;
  border-radius: 12px;
  display: flex;
  flex-flow: column;
  gap: 24px;

  ${Media.Phone`
    padding: 21px 20px;
  `};
`

export const StyledResumeScore = styled(ResumeScore)`
  padding-top: 0;
`

export const SuggestionBlock = styled.div`
  display: flex;
  flex-flow: column;
  gap: 16px;
`

export const SuggestionsContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;

  ${Media.Laptop`
    grid-template-columns: 1fr;
  `};

  ${Media.Tablet`
    grid-template-columns: 1fr 1fr;
  `};

  ${Media.Phone`
    grid-template-columns: 1fr;
  `};
`

export const StyledStarsIcon = styled(StarsIcon)`
  --bg-color: ${Colors.Indigo10};
  --star-color: ${Colors.Indigo50};
`

export const SuggestionItem = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;

  &:hover ${StyledStarsIcon} {
    --bg-color: ${Colors.Indigo50};
    --star-color: ${Colors.Indigo10};
  }
`

export const TailoredIconContainer = styled.div`
  padding: 0 6px;
  background-color: ${Colors.Indigo10};
  color: ${Colors.Indigo50};
  border-radius: 4px;
  transition: background-color 0.2s ease, color 0.2s ease;
  display: flex;

  ${SuggestionItem}:hover & {
    color: ${Colors.Indigo10};
    background-color: ${Colors.Indigo50};
  }
`

export const SuggestionText = styled.span`
  ${Typography.sizes.Caption};
  color: ${Colors.Neutral90};
`

export const CompletionBadge = styled.span<{ $enableHover?: boolean; $width?: number }>`
  background: ${Colors.Green10};
  color: ${Colors.Green60};
  ${Typography.sizes.Tiny};
  ${FontWeights.DemiBold};
  border-radius: 4px;
  text-align: center;
  padding: 2px 0;
  width: ${props => props.$width || 32}px;
  transition: background 0.2s ease, color 0.2s ease;

  ${props =>
    props.$enableHover &&
    css`
      &:hover {
        background: ${Colors.Green50};
        color: white;
      }
    `}
`

export const CompletionSuggestionItem = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;

  &:hover ${CompletionBadge} {
    background: ${Colors.Green50};
    color: white;
  }
`

export const CompletionText = styled.span`
  ${Typography.sizes.Caption};
  color: ${Colors.Neutral90};
`
